import React, { Component } from 'react';
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap';
import { Styles } from "./styles/tabBox.js";

class TabBox extends Component {

    render() {
        return (
            <Styles>
                {/* Tab Box Area */}
                <section className="tab-section">
                    <Container>
                        <Tab.Container defaultActiveKey="why">
                            <Row>

                                {/* Left Tabs */}
                                <Col lg="3" md="4">
                                    <Nav className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="why"><i className="las la-arrow-right"></i> Why Care University</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="mission"><i className="las la-arrow-right"></i> Our Mission</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="vision"><i className="las la-arrow-right"></i> Our Vision</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="ranking"><i className="las la-arrow-right"></i> Our Achievements</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="research"><i className="las la-arrow-right"></i> Our Programs</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>

                                {/* Right Content */}
                                <Col lg="9" md="8">
                                    <Tab.Content>

                                        {/* WHY */}
                                        <Tab.Pane eventKey="why">
                                            <h4 className="tab-title">Why Choose Care University of Education</h4>
                                            <p className="tab-desc">
                                                Care University of Education provides a student-focused learning environment with experienced faculty,
                                                modern infrastructure, and career-oriented programs. We aim to build strong academic foundations
                                                while encouraging innovation, practical learning, and overall personality development.
                                            </p>
                                            <ul className="list-unstyled check-list">
                                                <li><i className="fa fa-check"></i> Industry-relevant courses designed for real-world success.</li>
                                                <li><i className="fa fa-check"></i> Supportive faculty providing personalized guidance.</li>
                                                <li><i className="fa fa-check"></i> Modern facilities for enhanced learning experience.</li>
                                            </ul>
                                        </Tab.Pane>

                                        {/* MISSION */}
                                        <Tab.Pane eventKey="mission">
                                            <h4 className="tab-title">Our Mission</h4>
                                            <p className="tab-desc">
                                                Our mission is to deliver quality education that empowers students with knowledge, skills, and values.
                                                We focus on academic excellence, innovation, and preparing students for successful careers in a
                                                competitive world.
                                            </p>
                                            <ul className="list-unstyled check-list">
                                                <li><i className="fa fa-check"></i> Provide high-quality education with practical exposure.</li>
                                                <li><i className="fa fa-check"></i> Encourage creativity, innovation, and critical thinking.</li>
                                                <li><i className="fa fa-check"></i> Develop responsible and skilled professionals.</li>
                                            </ul>
                                        </Tab.Pane>

                                        {/* VISION */}
                                        <Tab.Pane eventKey="vision">
                                            <h4 className="tab-title">Our Vision</h4>
                                            <p className="tab-desc">
                                                Our vision is to become a leading institution known for academic excellence, innovation, and
                                                student success. We aim to create future leaders who contribute positively to society.
                                            </p>
                                            <ul className="list-unstyled check-list">
                                                <li><i className="fa fa-check"></i> Build a center of excellence in education.</li>
                                                <li><i className="fa fa-check"></i> Foster leadership and global perspective.</li>
                                                <li><i className="fa fa-check"></i> Promote lifelong learning and growth.</li>
                                            </ul>
                                        </Tab.Pane>

                                        {/* ACHIEVEMENTS */}
                                        <Tab.Pane eventKey="ranking">
                                            <h4 className="tab-title">Our Achievements</h4>
                                            <p className="tab-desc">
                                                Care University of Education has achieved significant milestones through dedication to quality
                                                education and student success. Our growing reputation reflects our commitment to excellence.
                                            </p>
                                            <ul className="list-unstyled check-list">
                                                <li><i className="fa fa-check"></i> Thousands of successful students placed in top organizations.</li>
                                                <li><i className="fa fa-check"></i> Recognition for quality education and innovation.</li>
                                                <li><i className="fa fa-check"></i> Strong industry connections and career support.</li>
                                            </ul>
                                        </Tab.Pane>

                                        {/* PROGRAMS */}
                                        <Tab.Pane eventKey="research">
                                            <h4 className="tab-title">Our Academic Programs</h4>
                                            <p className="tab-desc">
                                                We offer a wide range of undergraduate and professional programs designed to meet industry
                                                demands and student aspirations. Our curriculum focuses on both theoretical and practical knowledge.
                                            </p>
                                            <ul className="list-unstyled check-list">
                                                <li><i className="fa fa-check"></i> BCA, BBA, and professional diploma courses.</li>
                                                <li><i className="fa fa-check"></i> Skill-based and career-oriented learning approach.</li>
                                                <li><i className="fa fa-check"></i> Continuous evaluation and student development support.</li>
                                            </ul>
                                        </Tab.Pane>

                                    </Tab.Content>
                                </Col>

                            </Row>
                        </Tab.Container>
                    </Container>
                </section>
            </Styles>
        )
    }
}

export default TabBox
